import { CustomerFIXConnections } from '@src/containers/Dealer/CustomerFIXConnections';
import type { CustomerFIXConnectionsPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerFIXConnectionsPanel({ api, params }: LayoutPanelProps<CustomerFIXConnectionsPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-fix-connections-panel"
    >
      <CustomerFIXConnections />
    </EntityAdminPanelShell>
  );
}
